'use strict';
define([
    'angular',
    'modules/seospider/exam/analysis/title/over/over.controller',
],function(
    angular,
    TitleOverCtrl
){
    var app=angular.module('app.seospider.exam.analysis.title.over', []);
    app.controller("TitleOverCtrl",TitleOverCtrl);
    return app;
});